import {
  closeSignatureInfoModal,
  openTypedDataSignatureInfoModal,
} from '#/reduxState/exchange/exchangeSignatureModal';
import { staticDispatch } from '#/reduxState/store';

import { TypedDataSignParams, signTypedData } from './typedData/eip712';

import type { DelegatedKeyAuthorization } from '#/reduxState/delegatedKey/authorizationReducer';
import type { IWallet } from '#/reduxState/wallet/walletReducer';

// const signHashWithModal = async (
//   wallet: IWallet,
//   delegatedWallet: DelegatedKeyAuthorization | undefined,
//   hash: string,
//   title?: string
// ): Promise<string> => {
//   const modalNeeded =
//     !delegatedWallet?.walletAddress &&
//     wallet.walletType !== 'keystore' &&
//     wallet.walletType !== 'privateKey';
//   if (modalNeeded) {
//     staticDispatch(openHashSignatureInfoModal({ title, signingHash: hash }));
//   }
//   try {
//     const signature = await signHash(wallet, delegatedWallet, hash);
//     return signature;
//   } catch (error) {
//     console.warn(error);
//     throw error;
//   } finally {
//     if (modalNeeded) {
//       staticDispatch(closeSignatureInfoModal());
//     }
//   }
// };

export const signTypedDataWithModal = async (
  wallet: IWallet,
  delegatedWallet: DelegatedKeyAuthorization | undefined,
  typedData: TypedDataSignParams,
  title?: string
): Promise<string> => {
  const modalNeeded =
    !delegatedWallet?.walletAddress &&
    wallet.walletType !== 'keystore' &&
    wallet.walletType !== 'privateKey';
  if (modalNeeded) {
    // const clonedTypedData = JSON.parse(JSON.stringify(typedData));
    // const typedDataActionTitle = Object.keys(typedData?.[1])?.[0];
    // if (clonedTypedData[2].nonce) {
    //   clonedTypedData[2].nonce = '...';
    // }

    staticDispatch(
      openTypedDataSignatureInfoModal({
        title,
        // typedDataStringified: [
        //   typedDataActionTitle,
        //   JSON.stringify(clonedTypedData[2], null, 4),
        // ].join('\n'),
      })
    );
  }
  try {
    const signature = await signTypedData(wallet, delegatedWallet, typedData);
    return signature;
  } catch (error) {
    console.warn(error);
    throw error;
  } finally {
    if (modalNeeded) {
      staticDispatch(closeSignatureInfoModal());
    }
  }
};
